export default __webpack_public_path__ + "static/media/select.aa8e293a.svg";